
import { Button, ComponentStyle} from '@/imports-files/components/delete-candidate-modal';
import { closeJob, REDIRECT}  from '@/imports-files/pages/clients/candidates/kanban';
import Modal from '@/components/common-modal/modal';
export function DuplicateEmailModal(props)
{
  return(
    <Modal
    type="info"
      className={`CandidateFilterModal`}
      noCloseIcon = {true}
      innerContent={
        <>
          <div className={`confirmcontainer`}>
          <span className={`normalweight ${ComponentStyle.DeleteCandidateModal__Message}`}>{props.duplicateEmail.message}</span>
          <div className={'textcenter'}>
            <Button buttonstyle={ComponentStyle.secondarybtn} onClick={() => props.setDuplicateEmail({state: false})} style={{maxWidth: "200px"}}> Close </Button>
          </div>
        </div>
        </>
      }

      />
  )
}
